import { render } from "./article.vue?vue&type=template&id=2c50709c&scoped=true&ts=true"
import script from "./article.vue?vue&type=script&lang=ts"
export * from "./article.vue?vue&type=script&lang=ts"

import "./article.vue?vue&type=style&index=0&id=2c50709c&lang=scss&scoped=true"
import "./article.vue?vue&type=style&index=1&id=2c50709c&lang=scss"

import exportComponent from "E:\\project\\help-center\\help-center-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c50709c"]])

export default __exports__